import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../tenant.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenant = inject(TenantService);
  const tenantId = tenant.getCurrentTenantId();

  if (tenantId) {
    req = req.clone({
      setHeaders: {
        'X-Tenant-ID': String(tenantId),
      },
    });
  }

  return next(req);
};
